module.exports = __webpack_public_path__ + "img/2026-09-21c_2.9e72c8e4.jpg";